export default __webpack_public_path__ + "static/media/III - 2024.c82b33e7.pdf";